<script lang="ts">
  import { type Course } from '$lib/api/types';
  import { toast } from '$lib/stores/toast.svelte';
  import { faLoader } from '@itdev-fortawesome/pro-solid-svg-icons/faLoader';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import Label from '../common/bootstrap/Label.svelte';
  import Input from '../common/bootstrap/Input.svelte';
  interface Props {
    course?: Course;
    onSave: (course: Pick<Course, 'name' | 'code'>) => Promise<void>;
  }

  let { course, onSave }: Props = $props();
  let courseCode = $state(course?.code ?? '');
  let courseCodeTouched = $state(false);
  let courseName = $state(course?.name ?? '');
  let courseNameTouched = $state(false);

  let pending = $state(false);

  async function handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    if (courseCode.length === 0 || courseCode.length > 16 || courseName.length === 0 || courseName.length > 512) {
      // form validation check. most browsers will handle this validation natively
      courseCodeTouched = true;
      courseCodeTouched = true;
      toast.showToast('danger', 'Please fix the validation errors and try again.');
      return;
    }

    pending = true;

    await onSave({
      code: courseCode,
      name: courseName,
    });

    pending = false;
    toast.showToast('success', 'Course has been saved!');
  }
</script>

<div class="row">
  <form class="col-12 col-md-6 mx-auto" onsubmit={handleSubmit}>
    <div class="mb-3">
      <Label for="course_id" class="is-required">Course ID</Label>
      <Input
        required
        maxlength={16}
        invalid={courseCodeTouched && courseCode.length === 0}
        feedback="Course ID is required and must be less than 16 characters."
        id="course_id"
        placeholder="e.g. NURS 31165"
        type="text"
        value={courseCode}
        oninput={e => {
          courseCode = e.currentTarget.value.toUpperCase();
        }}
        onblur={() => {
          courseCodeTouched = true;
        }}
      />
    </div>
    <div class="mb-3">
      <Label for="course_name" class="is-required">Course Name</Label>
      <Input
        required
        maxlength={512}
        invalid={courseNameTouched && courseName.length === 0}
        feedback="Course Name is required and must be less than 512 characters."
        id="course_name"
        placeholder="e.g. Nursing Care of the Childbearing Family"
        type="text"
        bind:value={courseName}
        onblur={() => {
          courseNameTouched = true;
        }}
      />
    </div>
    <div class="d-grid">
      <button class="btn btn-primary" disabled={pending}>
        {#if pending}
          <FontAwesomeIcon icon={faLoader} spin class="me-2" />Saving...
        {:else}
          Save
        {/if}
      </button>
    </div>
  </form>
</div>
